import type { ReactNode } from 'react';

interface PageContainerProps {
  title: string;
  action?: ReactNode;
  children: ReactNode;
}

export function PageContainer({ title, action, children }: Readonly<PageContainerProps>) {
  return (
    <div className="space-y-5">
      {(title || action) && (
        <div className="flex items-center justify-between">
          {title && <h1 className="text-2xl font-bold text-black leading-9">{title}</h1>}
          {action && <div>{action}</div>}
        </div>
      )}
      {children}
    </div>
  );
}
